var render = function render(){
  var _vm$videoItem$videoTh;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "mt-5",
    attrs: {
      "id": "selected-video"
    }
  }, [_c('div', {
    staticClass: "container-fluid px-3 px-lg-5 px-xl-5"
  }, [_c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-12 p-0 selected-video-container"
  }, [_c('VideoLibraryItem', {
    attrs: {
      "videoId": _vm.videoItem.videoId,
      "videoTitle": _vm.videoItem.videoTitle,
      "videoTextDescription": _vm.videoItem.videoTextDescription,
      "videoThumbnail": (_vm$videoItem$videoTh = _vm.videoItem.videoThumbnail) !== null && _vm$videoItem$videoTh !== void 0 && _vm$videoItem$videoTh.includes('https://projectspectrumlearning.io/') ? _vm.videoItem.videoThumbnail : require(`@assetsImages/${_vm.videoItem.videoThumbnail}.png`),
      "videoSrc": _vm.videoItem.videoSrc,
      "isMP4Video": _vm.videoItem.isMP4Video,
      "videoClasses": 'flex-lg-row flex-xl-row justify-content-center',
      "columnClass": 'col-12 col-lg-6 col-xl-6',
      "videoContainerClasses": 'video-container-padding',
      "isVideoPlayerPlayer": _vm.isVideoPlayerPlayer,
      "showShareButtonFromLeft": _vm.isDesktop,
      "videoShare": _vm.videoItem.videoShare
    }
  })], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }